export default __webpack_public_path__ + "static/media/img_06.1c8c1a4e.jpg";